<template>
  <div class="obs_wrap">
    <Overlay :visible="!$route.meta.allowAutoSidebar" />
    <GLoading size="large" v-if="isLoadingNoti" />
    <template v-else>
      <div class="obs_topbar">
        <svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M30.0516 0.0104125L0.493575 9.07859C0.374171 9.1106 0.309041 9.23862 0.341606 9.36664L2.62114 16.7172C2.65371 16.8346 2.78397 16.9092 2.90337 16.8666L24.5915 10.2094C25.6227 9.8894 26.502 9.18528 27.0013 8.22512C28.3473 5.68603 29.4654 3.04025 30.3229 0.298461C30.3881 0.117097 30.2252 -0.0429298 30.0516 0.0104125Z" fill="#FFBB1C" />
          <path d="M22.9633 12.7257L4.59674 18.3586C4.49904 18.3906 4.43391 18.4973 4.46648 18.604L6.39866 24.813C6.43122 24.909 6.53977 24.9731 6.63747 24.9411L18.3499 21.3458C19.2292 21.0791 19.9565 20.471 20.3907 19.6708C21.5304 17.5265 22.4748 15.2861 23.1912 12.971C23.2455 12.8217 23.1044 12.683 22.9633 12.7257Z" fill="#E8486C" />
          <path d="M14.9665 24.3947L8.32331 26.4323C8.23647 26.4537 8.19305 26.5497 8.21476 26.635L9.843 31.8839C9.86471 31.9693 9.9624 32.0226 10.0492 31.9906L11.0696 31.6812C11.8077 31.4572 12.4265 30.9451 12.7955 30.2623C13.7616 28.4487 14.554 26.5604 15.1619 24.5974C15.2162 24.4693 15.0968 24.352 14.9665 24.3947Z" fill="#476DF2" />
        </svg>
      </div>
      <div class="obs_toolbar" :class="{ hidding: currentStep == 1 }" v-show="[1, 2, 3, 4].includes(currentStep)">
        <div class="obs_backstep" @click="previousStep">
          <i class="icon icon-arrow-left"></i>
          <span>{{ $t("onboardingStep.toolbar.button") }}</span>
        </div>
        <div class="indicators">
          <svg class="runner" :class="{ 'active-slide-1': currentStep == 2, 'active-slide-2': currentStep == 3, 'active-slide-3': currentStep == 4 }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="6" r="6" fill="currentColor" />
          </svg>
          <div class="outlines">
            <div class="outline-container">
              <div class="outline-spacer"></div>
              <svg :class="{ 'active active-slide-0': currentStep == 2 || currentStep == 3 || currentStep == 4 }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="6" fill="currentColor" @click="indicatorNav(2)" />
              </svg>
              <div class="outline-spacer"></div>
            </div>
            <div class="outline-container">
              <svg :class="{ 'active active-slide-1': currentStep == 3 || currentStep == 4 }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="6" fill="currentColor" @click="indicatorNav(3)" />
              </svg>
              <div class="outline-spacer"></div>
            </div>
            <div class="outline-container">
              <svg :class="{ 'active active-slide-2': currentStep == 4 }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="6" fill="currentColor" @click="indicatorNav(4)" />
              </svg>
              <div class="outline-spacer"></div>
            </div>
          </div>
        </div>
      </div>
      <transition name="slide-fade">
        <Welcome :step="currentStep" @next="nextStep" v-if="currentStep == 1" :skippable="skippable" :userName="userName" @data="getFormDataSkiped"></Welcome>
        <Experience :step="currentStep" @next="nextStep" v-if="currentStep == 2"></Experience>
        <Describes :step="currentStep" @next="nextStep" v-if="currentStep == 3"></Describes>
        <PrimaryGoal :step="currentStep" @next="nextStep" v-if="currentStep == 4" @data="getFormData"></PrimaryGoal>
        <LetGetStarted :step="currentStep" @next="nextStep" v-if="currentStep == 5" @data="getFormDataSubcribe"></LetGetStarted>
      </transition>
      <Tooltip :pointer="true" :width="'auto'" :maxWidth="'unset'" :event="'click'" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { Welcome, Experience, Describes, PrimaryGoal, LetGetStarted } from "../components";
import { mutations } from "@/store/onboarding/types.js";
import obsLocalData from "@/utils/obsLocalData.js";
import { Overlay } from "@/core/components";
// check welcome
// import checkGlobalConfigs from '@/mixins/checkGlobalConfigs';

export default {
  name: "OnboardingStep",
  components: {
    Welcome,
    Experience,
    Describes,
    PrimaryGoal,
    LetGetStarted,
    Overlay
  },
  // check welcome
  // mixins: [
  //   checkGlobalConfigs(),
  // ],
  data() {
    return {
      currentStep: 1,
      endStep: 5,
      beginStep: 1,
      dataForm: {},
      userName: "",
      skippable: false,
      isLoadingNoti: true,
      activeSlideIndex: 0,
      slides: [{}, {}, {}]
    };
  },
  computed: {
    ...mapGetters("onboarding", {
      totalTime: "totalTime",
      dataSubmit: "dataSubmit",
      dataSubcribeSubmit: "dataSubcribeSubmit"
    }),
    ...mapState("onboarding", {
      obsState: state => state
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    })
  },
  created() {
    if( !this.shopInfo ){
      this.whoAmI({
        getSurvey: true,
        getGA: true,
        onSuccess: () => {
          this.isLoadingNoti = false;
          // this.checkStatusOBS();
          const shopifyDomain = this.shopInfo ? this.shopInfo.shopifyDomain : obsLocalData.getShopName();
          if (obsLocalData.check(shopifyDomain)) {
            let lastSurvey = {};
            lastSurvey = obsLocalData.get(shopifyDomain);
            if (lastSurvey.store) {
              this.currentStep = lastSurvey.store.currentStep || 1;
            }
          } else {
            this.currentStep = 1;
          }
        }
      });
    } else {
      this.isLoadingNoti = false;
      // this.checkStatusOBS();
    }
  },
  methods: {
    ...mapMutations("onboarding", {
      obsRecuseData: mutations.OBS_RECUSE_DATA
    }),
    ...mapActions("onboarding", {
      submitSurveyInfo: "obsSubmitSurveyinfo"
    }),
    ...mapActions("account", {
      whoAmI: "accountWhoAmI"
    }),
    onTabChangeHandler() {},
    nextStep(step) {
      if (step < this.endStep) {
        this.currentStep = step + 1;
      } else {
        this.currentStep = this.endStep;
      }
      // [auto scroll]
      // if(this.currentStep > 1){
      //   this.checkScreenSize()
      // }
    },
    // indicatorNav(e) {
    //   console.log(e);
    // },
    indicatorNav(step) {
      if (step > this.currentStep) {
        return;
      } else {
        this.activeSlideIndex = step;
        this.currentStep = step;
      }
    },
    previousStep() {
      if (this.currentStep > this.beginStep) {
        this.currentStep--;
      } else {
        this.currentStep = this.beginStep;
      }
      // [auto scroll]
      // if(this.currentStep > 1){
      //   this.checkScreenSize()
      // }
    },
    // getFormData(data) {
    getFormData() {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      let dataSubmit = {};
      let dataBody = {};
      dataSubmit = { ...this.dataSubmit };
      dataSubmit["onboarding_completion_time"] = this.totalTime;
      dataBody = {
        data: dataSubmit,
        status: "step4",
        shopifyDomain: shopifyDomain
      };
      this.submitSurveyInfo(dataBody)
        .then(() => {
          obsLocalData.set(false, "almostDoneFail", shopifyDomain);
        })
        .catch(() => {
          obsLocalData.set(true, "almostDoneFail", shopifyDomain);
          obsLocalData.set(this.currentStep, "currentStep", shopifyDomain);
        });
    },
    getFormDataSubcribe() {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      let dataSubmit = {};
      let dataBody = {};
      dataSubmit = { ...this.dataSubcribeSubmit };
      dataBody = {
        data: dataSubmit,
        status: "final",
        shopifyDomain: shopifyDomain
      };
      this.submitSurveyInfo(dataBody)
        .then(() => {
          obsLocalData.set(false, "subscribedFail", shopifyDomain);
        })
        .catch(() => {
          obsLocalData.set(true, "subscribedFail", shopifyDomain);
          obsLocalData.set(this.currentStep, "currentStep", shopifyDomain);
        });
    },
    getFormDataSkiped() {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      let dataSubmit = {};
      let dataBody = {};
      dataSubmit = { onboarding_skipped: true };
      dataBody = {
        data: dataSubmit,
        status: "skip",
        shopifyDomain: shopifyDomain
      };
      setTimeout(() => {
        this.$router.push({ name: "Dashboard", query: { obs: "skipped" } });
      }, 100);
      this.submitSurveyInfo(dataBody).catch(() => {
        obsLocalData.set(true, "skippedFail", shopifyDomain);
      });
    },
    isObjectBlank(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },
    getFirstName() {
      return obsLocalData.getName();
    },
    checkStatusOBS() {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      const surveys = this.shopInfo ? this.shopInfo.surveys : [];

      // Nếu có key thì set surveys, dùng để test page welcome
      // if (this.isKeyValid("testShowWelcome")) {
      //   surveys = [{ "name": "onboarding", "skippable": true }]
      // }
      
      this.userName = this.shopInfo ? this.shopInfo.firstName : this.getFirstName();
      if (!surveys || (surveys && surveys.length == 0)) {
        obsLocalData.remove(shopifyDomain);
        this.$router.push({ name: "Dashboard" });
      } else {
        const surveyObs = surveys.filter(sv => sv.name == "onboarding") || [];
        if (!surveyObs || (surveyObs && surveyObs.length == 0)) {
          obsLocalData.remove(shopifyDomain);
          this.$router.push({ name: "Dashboard" });
        } else {
          this.skippable = surveyObs[0].skippable;
        }
      }
    },
    // checkScreenSize() {
    //   const windowHeight = window.innerHeight;
    //   if (600 <= windowHeight && windowHeight < 700) {
    //     setTimeout(() => {
    //       this.scrollTo(110)
    //     }, 800);
    //   } else if (700 <= windowHeight && windowHeight <= 750) {
    //     setTimeout(() => {
    //       this.scrollTo(90)
    //     }, 800);
    //   }
    // },
    // scrollTo(topx10){
    //   let i = 10;
    //   let int = setInterval(function() {
    //     window.scrollTo(0, i);
    //     i += 10;
    //     if (i >= topx10) clearInterval(int);
    //   }, 20);
    // }
  }
};
</script>

<style lang="scss" scoped>
$indicator-width: 12px;
$indicator-margin: 8px;
$runner-transition: 0.25s ease;
@mixin indicator-size() {
  height: $indicator-width;
  width: $indicator-width;
}

.obs_wrap * {
  font-family: "Inter", sans-serif;
}
.obs_wrap {
  width: 100%;
  min-height: 100%;
  background: $light1;
  top: 0;
  right: 0;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  .obs_topbar {
    height: 96px;
    width: 100%;
    min-width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 121px;
  }
  ::v-deep.no_padding_left {
    padding-left: 0;
  }
  ::v-deep.no_padding_right {
    padding-right: 0;
  }
  ::v-deep.obs_container {
    width: 100%;
    height: calc(100% - 158px);
    overflow: hidden;
    padding-bottom: 60px;
  }
  ::v-deep.obs_btn {
    font-family: "Inter", sans-serif;
    min-width: 161px;
    height: 40px;
    font-size: 14px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $textDarkModeHigh;
    font-weight: 500;
    background-color: $mono3;
    border: 0;
    cursor: pointer;
    &.gf_highlight_button {
      transition: all 500ms;
      animation: wf-blink-in 1s;
      border: 2px solid #3c67ff;
      box-shadow: 0 0 15px #3c67ff;
    }
    &:hover {
      background: $mono4;
    }
    &.disabled {
      background-color: $textDarkModeLow;
      &:hover {
        background: $textDarkModeLow;
      }
    }
    &.obs_btn_large {
      width: 240px;
      height: 48px;
      font-size: 20px;
    }
  }
  ::v-deep.obs_toolbar {
    width: 100%;
    padding: 0 121px;
    min-height: 30px;
    margin-bottom: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &.hidding {
      opacity: 0;
    }
    &.init_animate {
      animation-name: toolbar_fade;
      animation-timing-function: linear;
      animation-duration: 200ms;
      animation-delay: 0;
    }
    .obs_backstep {
      width: 59px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      left: 0;
      cursor: pointer;
      color: $textLightModeLow;
      font-size: 14px;
      font-weight: 500;
      &:hover {
        color: $textLightModeHigh;
      }
      i {
        margin-right: 11.35px;
      }
    }
    .obs_indicator-wrap {
      width: calc(100% - 118px);
      margin-right: 59px;
      display: flex;
      justify-content: center;
      align-content: center;
    }
    .indicators {
      width: calc(100% - 118px);
      margin-right: 59px;
      display: flex;
      justify-content: center;
      align-content: center;
      font-size: 0;
      & > * {
        cursor: pointer;
      }
      .runner {
        @include indicator-size();
        color: $mono3;
        opacity: 1;
        border-radius: 50%;
        transition: transform $runner-transition;
        @for $i from 0 through 9 {
          &.active-slide-#{$i} {
            transform: translateX($i * ($indicator-width + $indicator-margin));
          }
        }
      }
      .outlines {
        line-height: unset;
        height: 12px;
        color: rgba(51, 51, 51, 0.7);
        .outline-container {
          display: inline-block;
          line-height: unset;
          svg.active {
            color: $mono3;
          }
          .outline {
            @include indicator-size();
            display: inline-block;
            cursor: pointer;
          }
          .outline-spacer {
            @include indicator-size();
            width: $indicator-margin;
            display: inline-block;
            background: transparent;
          }
        }
      }
    }
  }
  ::v-deep.obs_heading {
    margin-bottom: 32px;
    text-transform: capitalize;
  }
  ::v-deep.obs_sub-heading {
    font-weight: 400;
    margin-bottom: 8px;
  }
  ::v-deep.obs_body {
    width: 100%;
    height: 505px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    &.height473{
      height: 473px;
    }
    .gp_base-select_dropdown {
      max-height: 18vh;
      overflow-y: scroll;
    }
  }
  ::v-deep.obs_body-experience {
    max-width: 510px;
    margin: auto;
    .obs_experience-item {
      width: 100%;
      height: 160px;
      background: rgba(244, 244, 244, 0.3);
      border: 2px solid $light3;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
      align-items: center;
      p {
        text-align: center;
        padding: 0 10px;
      }
      &.obs_experience-item svg {
        color: $light1;
      }
      &.obs_experience-item svg #fixed_color {
        color: $mono1;
      }
      &.obs_experience-item:hover svg #main_stroke {
        stroke: $mono3;
        opacity: 1;
      }
      &:hover {
        border-color: $mono3;
      }
      &.selected {
        border-color: $mono3;
        background: rgba($mono3, 0.1);
        #main_stroke {
          stroke: $mono3;
          opacity: 1;
        }
      }
      h4 {
        margin-top: 24px;
      }
      p {
        margin-top: 4px;
      }
    }
  }
  ::v-deep.obs_footer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    &.mt-44 {
      margin-top: 44px;
    }
    &.mt-100 {
      margin-top: 100px;
    }
  }
  ::v-deep.obs_body-describes {
    max-width: 576px;
    margin: 0 auto;
    &.mw-475 {
      max-width: 475px;
    }
    .h-fit-content {
      height: fit-content;
    }
    .obs_describes-item {
      min-height: 60px;
      box-sizing: border-box;
      width: 100%;
      background: $light1;
      border: 1px solid $light3;
      display: flex;
      padding-left: 30px;
      justify-content: flex-start;
      align-items: center;
      transition: all 200ms;
      &.pdl20 {
        padding-left: 20px;
      }
      .obs_invalid {
        display: block;
        margin-top: 8px;
        color: $accentRed;
        font-style: italic;
        font-weight: 400;
        margin-left: 32px;
      }
      .gp-checkbox-wrap {
        min-height: inherit;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
      }
      &.fl-col {
        flex-direction: column;
        align-items: flex-start;
        &.padding_expand {
          padding: 18px 26px 24px 20px;
          transition: padding 0ms;
          .gp-checkbox-wrap {
            min-height: unset;
            margin-bottom: 12px;
          }
          textarea {
            margin-left: 32px;
            width: calc(100% - 32px);
          }
        }
      }
      &.obs_describes-item:hover,
      &.obs_describes-item.active {
        border-color: $mono3;
        background-color: $light1;
        .gp-checkbox-text {
          color: $mono3;
        }
      }
      &.obs_describes-item.--selection {
        border: none;
        display: block;
        padding: 0;
        label {
          display: block;
          margin-bottom: 8px;
        }
        .overflow-hidden {
          overflow: unset;
        }
      }
      .gp_base-select {
        width: 100%;
      }
      textarea {
        width: 100%;
        border: 1px solid $light3;
        box-sizing: border-box;
        background: $light1;
        resize: none;
        padding: 16px;
        height: 0;
        display: none;
        box-sizing: border-box;
        &.showing {
          height: 74px;
          display: block;
        }
        &.invalid {
          outline: 1px solid rgba(219, 67, 67, 0.56);
          filter: drop-shadow(0 0 0.15rem rgba(219, 67, 67, 0.56));
        }
        &.focus {
          outline: 1px solid #eeeeee;
          filter: drop-shadow(0 0 0.15rem #eeeeee);
        }
      }
    }
    .obs_icon-item {
      height: 60px;
      width: 100%;
      background-color: $light1;
      border: 1px solid $light3;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      border-radius: 3px;
      color: $textLightModeHigh;
      &:visited {
        color: inherit;
      }
      .--left_icon {
        width: 60px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-right: 1px solid $light3;
        color: $textLightModeLow;
        // border-top-left-radius: 3px;
        // border-bottom-left-radius: 3px;
      }
      .--text {
        padding-left: 24px;
        height: 100%;
        width: calc(100% - 103px);
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .--right_icon {
        width: 43px;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        transform: translateX(12px);
        align-items: center;
        svg {
          display: none;
        }
      }
      &.obs_icon-item:hover {
        border-color: $mono3;
        .--left_icon {
          background-color: $mono3;
          border-color: $mono3;
          color: $light1;
        }
        .--text {
          color: $mono3;
        }
        .--right_icon {
          color: $mono3;
          animation-name: left-to-right;
          animation-timing-function: linear;
          animation-duration: 500ms;
          animation-delay: 0;
          svg {
            display: block;
          }
        }
      }

      &.obs_icon-item.selected {
        border-color: $mono3;
        .--left_icon {
          background-color: $mono3;
          border-color: $mono3;
          color: $light1;
        }
        .--text {
          color: $mono3;
        }
        .--right_icon {
          color: $mono3;
          svg {
            display: block;
          }
        }
      }
    }
    .goback_link {
      display: block;
      text-decoration: none;
      color: $mono3;
      font-weight: 500;
      cursor: pointer;
      transition: all 200ms;
      &:hover {
        color: $mono5;
        text-decoration: underline;
      }
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
  position: absolute;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  position: absolute;
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
  position: absolute;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
  position: absolute;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}

@keyframes left-to-right {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(12px);
  }
}
@keyframes indicator-scale {
  0% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes toolbar_fade {
  from {
    transform: translateX(-12px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes wf-blink-in {
	40% {
		opacity: 1;
	}
}
@media screen and (max-height: 790px) {
  .obs_wrap {
    ::v-deep.obs_body {
      height: auto;
      min-height: 400px;
      &.height473{
        height: auto;
        min-height: 368px;
      }
    }
    ::v-deep.obs_heading{
      margin-bottom: 16px;
    }
    ::v-deep.obs_footer {
      margin-top: 32px;
    }
    ::v-deep.obs_body-describes {
      .obs_describes-item {
        &.padding_expand {
          padding: 18px 20px 18px 20px!important;
        }
      }
    }

    ::v-deep.obs_body-describes {
      .obs_describes-item {
        textarea {
          &.showing {
            height: 45px;
            padding: 8px 16px;
          }
        }
      }
    }

  }
}
</style>
